import cx from 'classnames'
import IconSVG from 'svg-inline-react'
import errorIconSrc from '!svg-inline!images/svg/action-error.svg'

import styles from '../Action/style.styl'

const ActionError = ({ children }) =>
  <div className={cx(styles.Action, 'flex')}>
    <div className="action-icon">
      <IconSVG src={errorIconSrc} />
    </div>
    <div className="action-content action-error">
      {children}
    </div>
  </div>

export default ActionError



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/ActionError/index.js